// Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

import keyMirror from 'key-mirror';

export default keyMirror({
    POST_LIST_SCROLL_CHANGE: null
});



// WEBPACK FOOTER //
// ./utils/event_types.jsx